import { types } from 'mobx-state-tree';

const BalancePaymentWidget = types.model('BalancePaymentWidget', {
  html_widget: types.maybeNull(types.string)
});

export default BalancePaymentWidget;



// WEBPACK FOOTER //
// ./src/models/BalancePaymentWidget.js